import React from 'react';
import { bookingShape } from 'constants/propTypes';
import { intlShape } from 'react-intl';
import moment from 'moment';
import { getPriceWithCurrency } from './utils';
import { FormattedMessage } from 'react-intl';
import { StyledDiv, StyledH2 } from './styles';
import { bookingStatus } from 'types/booking';
import PropTypes from 'prop-types';

export function PaymentDetails({ booking, intl, isReviewQuote = false }) {
  const totalPricePaid = booking.payments.reduce((acc, payment) => {
    if (payment.paymentStatus === 'S') acc += payment.amountWithCurrency;
    return acc;
  }, 0);
  const finalBalanceDue = booking.totalPriceToBePaidWithCurrency - booking.onHoldWithCurrency.depositAmount;
  const canBePutOnHold = !!booking.onHoldWithCurrency.depositAmount && moment(booking.onHoldWithCurrency.expiryTimestamp).isValid();

  return (
    <>
      <StyledH2>
        <FormattedMessage id="quoteConfirmation.paymentDetails.title" />
      </StyledH2>
      <StyledDiv>
        {(booking.status === bookingStatus.TEMPORARILY_ON_HOLD || (isReviewQuote && canBePutOnHold)) && (
          <>
            <p data-testid="quoteConfirmation-paymentDetails-depositAmountDue">
              {intl.formatMessage({
                id: 'quoteConfirmation.paymentDetails.depositAmountDue'
              })}
              : {getPriceWithCurrency(booking.onHoldWithCurrency.depositAmount, booking.currency)}
            </p>
            <p data-testid="quoteConfirmation-paymentDetails-depositAmountDueDate">
              {intl.formatMessage({
                id: 'quoteConfirmation.paymentDetails.depositDueDate'
              })}
              : {moment(booking.expiryTimestamp).isValid() ? moment(booking.expiryTimestamp).format('dddd Do MMMM YYYY') : '-'}
            </p>
          </>
        )}

        {isReviewQuote && !canBePutOnHold && (
          <p data-testid="quoteConfirmation-paymentDetails-bookingCannotBePutOnHold">
            {intl.formatMessage({
              id: 'reviewQuote.bookingCannotBePutOHold'
            })}
          </p>
        )}

        {booking.status === bookingStatus.ON_HOLD && (
          <p data-testid="quoteConfirmation-paymentDetails-nonRefundableDeposit">
            {intl.formatMessage({
              id: 'quoteConfirmation.paymentDetails.nonRefundableDeposit'
            })}
            : {getPriceWithCurrency(totalPricePaid, booking.currency)}
          </p>
        )}
        {!isReviewQuote ? (
          <>
            <p data-testid="quoteConfirmation-paymentDetails-finalBalanceDue-notReviewQuote">
              {intl.formatMessage({
                id: 'quoteConfirmation.paymentDetails.finalBalanceDue'
              })}
              : {getPriceWithCurrency(finalBalanceDue, booking.currency)}
            </p>
            <p data-testid="quoteConfirmation-paymentDetails-finalBalanceDueDate-notReviewQuote">
              {intl.formatMessage({
                id: 'quoteConfirmation.paymentDetails.finalBalanceDueDate'
              })}
              : {moment(booking.onHoldWithCurrency.expiryTimestamp).format('dddd Do MMMM YYYY')}
            </p>
          </>
        ) : (
          canBePutOnHold && (
            <>
              <p data-testid="quoteConfirmation-paymentDetails-finalBalanceDue">
                {intl.formatMessage({
                  id: 'quoteConfirmation.paymentDetails.finalBalanceDue'
                })}
                : {getPriceWithCurrency(finalBalanceDue, booking.currency)}
              </p>
              <p data-testid="quoteConfirmation-paymentDetails-finalBalanceDueDate">
                {intl.formatMessage({
                  id: 'quoteConfirmation.paymentDetails.finalBalanceDueDate'
                })}
                : {moment(booking.onHoldWithCurrency.expiryTimestamp).format('dddd Do MMMM YYYY')}
              </p>
            </>
          )
        )}

        <p data-testid="quoteConfirmation-paymentDetails-finalBalanceDueDate-overallCost">
          {intl.formatMessage({
            id: 'quoteConfirmation.paymentDetails.overallCost'
          })}
          :{'  '}
          {getPriceWithCurrency(booking.totalPriceWithCurrency, booking.currency)}
        </p>
      </StyledDiv>
    </>
  );
}

PaymentDetails.propTypes = {
  booking: bookingShape.isRequired,
  intl: intlShape.isRequired,
  isReviewQuote: PropTypes.bool
};

export default PaymentDetails;
